__turbopack_context__.v({
  "features_container": "features-module-scss-module__ASDwHG__features_container",
  "title": "features-module-scss-module__ASDwHG__title",
});
